import React from 'react';

import IconFieldDropdown from '../icons/icon-field-dropdown';
import IconFieldBudget from '../icons/icon-field-budget';
import IconFieldText from '../icons/icon-field-text';
import IconFieldReminder from '../icons/icon-field-reminder';
import IconFieldNumber from '../icons/icon-field-number';
import IconFieldUrl from '../icons/icon-field-url';
import IconFieldPhone from '../icons/icon-field-phone';
import IconFieldEmail from '../icons/icon-field-email';
import IconFieldLocation from '../icons/icon-field-location';
import IconFieldCurrency from '../icons/icon-field-currency';
import IconFieldCheckbox from '../icons/icon-field-checkbox';

import IconPrice from '../icons/icon-price';
import IconText from '../icons/icon-text';
import IconList from '../icons/icon-list';
import IconCalendarSimple from '../icons/icon-calendar-simple';
import IconNumber from '../icons/icon-number';
import IconLink from '../icons/icon-link';
import IconPhone from '../icons/icon-phone';
import IconEmail from '../icons/icon-email';
import IconLocation from '../icons/icon-location';
import IconMoney from '../icons/icon-money';
import IconCheckCircled from '../icons/icon-check-circled';

import IconRoadmap from '../icons/icon-roadmap';
import IconTask from '../icons/icon-task';
import IconUsers from '../icons/icon-users';
import IconProject from '../icons/icon-project';

export const CUSTOM_FIELDS = [
    {
        id: 'budget',
        name: 'Budget',
        description: 'Set a budget.',
        color: '#009084',
        icon: <IconFieldBudget size="18px" />,
        fieldIcon: <IconPrice />
    },
    {
        id: 'text',
        name: 'Text',
        description: 'Capture key information like name or location.',
        color: '#df9100',
        icon: <IconFieldText size="17px" />,
        fieldIcon: <IconText />
    },
    {
        id: 'dropdown',
        name: 'Dropdown',
        description: 'Add statuses with colors or regular dropdowns.',
        color: '#c44ae4',
        icon: <IconFieldDropdown />,
        fieldIcon: <IconList />
    },
    // {
    //     id: 'reminder',
    //     name: 'Reminder',
    //     description: 'Get push or email reminders (e.g., daily stand-up).',
    //     color: '#009084',
    //     icon: <IconFieldReminder size="16px" />,
    //     fieldIcon: <IconCalendarSimple />
    // },
    {
        id: 'number',
        name: 'Number',
        description: 'Use number fields for accounting, inventory or tracking.',
        color: '#c65010',
        icon: <IconFieldNumber />,
        fieldIcon: <IconNumber />
    },
    {
        id: 'url',
        name: 'URL',
        description: 'Add clickable links to websites.',
        color: '#017ec0',
        icon: <IconFieldUrl size="17px" />,
        fieldIcon: <IconLink />
    },
    {
        id: 'phone',
        name: 'Phone',
        description: 'Use Nifty as a CRM by adding phone numbers.',
        color: '#c65010',
        icon: <IconFieldPhone />,
        fieldIcon: <IconPhone />
    },
    {
        id: 'email',
        name: 'Email',
        description: 'Track clients, vendors, leads, and more.',
        color: '#df9100',
        icon: <IconFieldEmail size="17px" />,
        fieldIcon: <IconEmail />
    },
    {
        id: 'location',
        name: 'Location',
        description: 'Enter zip code, street, city or country.',
        color: '#017ec0',
        icon: <IconFieldLocation size="15px" />,
        fieldIcon: <IconLocation />
    },
    {
        id: 'currency',
        name: 'Currency',
        description: 'Add information such as budget, cost, or price.',
        color: '#c44ae4',
        icon: <IconFieldCurrency size="19px" />,
        fieldIcon: <IconMoney />
    },
    {
        id: 'checkbox',
        name: 'Checkbox',
        description: 'Yes or no? Add simple true or false checkboxes.',
        color: '#009084',
        icon: <IconFieldCheckbox />,
        fieldIcon: <IconCheckCircled />
    }
]



export const ASSOCIATION_OPTIONS = [
    {
        id: 'milestone',
        rawLabel: 'Roadmap',
        label: <React.Fragment><IconRoadmap /> Roadmap</React.Fragment>
    },
    {
        id: 'task',
        rawLabel: 'Tasks',
        label: <React.Fragment><IconTask /> Tasks</React.Fragment>
    },
    {
        id: 'member',
        rawLabel: 'People',
        label: <React.Fragment><IconUsers /> People</React.Fragment>
    },
    {
        id: 'project',
        rawLabel: 'Projects',
        label: <React.Fragment><IconProject /> Projects</React.Fragment>
    }
];

export const ROLE_OPTIONS = [
    {
        id: 'manager',
        label: 'Admins'
    },
    {
        id: 'regular',
        label: 'Team members'
    },
    {
        id: 'client',
        label: 'Guests'
    }
];